jQuery(function ($) {

    const $gallery = $('.product-gallery');
    if ($gallery.hasClass('image-count-1')) {
        return;
    }

    const $main = $('.main-slider', $gallery);
    const $nav = $('.nav-slider', $gallery);

    $main.slick({
        rows: 0,
        arrows: false,
        draggable: false,
        fade: true,
        slidesToShow: 1,
        variableWidth: false,
        adaptiveHeight: false,
        waitForAnimate: false,
    });

    if ($nav.length) {

        $nav.on('click', '.slick-slide img', function () {
            $nav.slick('slickGoTo', $(this).parent().data('slick-index'));
        });

        $nav.slick({
            rows: 0,
            arrows: true,
            asNavFor: $main,
            slidesToShow: 4,
            variableWidth: false,
            adaptiveHeight: false,
            waitForAnimate: false,
            prevArrow: $('.slick-prev', $gallery),
            nextArrow: $('.slick-next', $gallery),
        });
    }
});